import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { LibraryAsset } from '../models/library-asset';
import { AssetService } from '../services/asset.service';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'dac-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss']
})
export class AssetListComponent implements OnInit,OnChanges {

  @Input() type:'exercise'|'article'|null;
  @Output() selected = new EventEmitter<LibraryAsset>();
  public Assets:LibraryAsset[];

  constructor(private assetService:AssetService, private alertService:AlertService) { }
  
  
  ngOnChanges(changes: SimpleChanges): void {
    this.loadAssetsForType(this.type); // reload our changes.
  }

  ngOnInit() {
    if (!this.type) {
      this.type = 'exercise'; 
    }
    this.loadAssetsForType(this.type);
    
  }

  private loadAssetsForType(type) {
    this.assetService.getAssetsByType(type).then(assets => {
      assets.sort((a, b) => a.title.localeCompare(b.title)); // make sure we are sorted by name here.
      this.Assets = assets;
    })
    .catch(error => {
      console.error(error);
      this.alertService.error("Failed to retrieve the library resources.  Check your internet connection and refresh the page");
    })
  }

  public viewAsset(asset: LibraryAsset) {
    console.log("selecting ", asset);
    this.selected.emit(asset);
  }

}



// WEBPACK FOOTER //
// ./src/app/library-assets/asset-list/asset-list.component.ts